/* Native optional-case presentation. Prices and checkout remain Shopify variants. */
(function (root, factory) {
  const api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) root.OptionalCasePilot = api;
})(typeof window !== 'undefined' ? window : null, function (win) {
  'use strict';
  const states = new WeakMap();
  let choiceGroup = 0;
  const openSheets = new Set();
  let scrollSnapshot = null;
  const idOf = value => String(value == null ? '' : value);
  const inStock = v => !!(v && v.available && (!v.inventory_management || v.inventory_quantity > 0));
  function initialVariant(variants, index, without, explicitId) {
    const explicit = variants.find(v => idOf(v.id) === idOf(explicitId));
    if (explicit) return explicit;
    const base = variants.filter(v => v.options[index] === without);
    return base.find(inStock) || base.find(v => v.available) || base[0] || null;
  }
  function pairFor(variants, options, index, without, withCase) {
    const same = v => v.options.length === options.length && v.options.every((value, i) => i === index || value === options[i]);
    return {without: variants.find(v => same(v) && v.options[index] === without) || null,
      with: variants.find(v => same(v) && v.options[index] === withCase) || null};
  }
  function upgradeFor(pair, reference) {
    if (!pair.without || !pair.with || !Number.isSafeInteger(pair.without.price) || !Number.isSafeInteger(pair.with.price) || !Number.isSafeInteger(reference) || reference <= 0) return null;
    const amount = pair.with.price - pair.without.price;
    if (amount < 0) return null;
    return {amount, saving: Math.max(0, reference - amount), percent: amount < reference ? Math.round((reference - amount) / reference * 100) : 0};
  }
  function catalogueMatch(result, doc) {
    const tag = doc && doc.querySelector('[data-optional-case-catalogue]');
    if (!tag) return false;
    try { const configured = JSON.parse(tag.textContent); return idOf(configured.id) === idOf(result.id) && configured.handle === result.handle; }
    catch (_) { return false; }
  }
  function money(cents, config) {
    // The shop's JS money template can contain its base-currency suffix. Markets
    // prices are presentment cents; format their explicit cart currency instead.
    try { return new Intl.NumberFormat(win.document.documentElement.lang || 'en', {style:'currency', currency:config.currency, currencyDisplay:'code'}).format(cents / 100); }
    catch (_) { return (cents / 100).toFixed(2) + ' ' + config.currency; }
  }
  function formatPrice(container, cents) {
    const tag = container && container.querySelector('[data-optional-case-config]');
    if (!tag) return null;
    try { const config = JSON.parse(tag.getAttribute('data-optional-case-config') || tag.textContent); return money(cents, config); }
    catch (_) { return null; }
  }
  function readOptions(state) { return state.selector.selectors.map(item => item.element.value); }
  function selected(state) {
    const values = readOptions(state);
    return state.config.variants.find(v => v.options.length === values.length && v.options.every((value, i) => value === values[i])) || null;
  }
  function productNodes(state, selector, attribute) {
    const details = state.container.closest('.product__details') || state.container.parentElement;
    const forms = details.querySelectorAll('[data-optional-case-pilot]');
    return Array.from(details.querySelectorAll(selector)).filter(el => {
      const owner = el.getAttribute(attribute);
      if (owner) return owner === idOf(state.config.productId);
      // Older markup without an owner remains supported only in an unambiguous
      // single-product details block. New markup always carries its product ID.
      const form = el.closest('[data-optional-case-pilot]');
      return form ? form === state.container : forms.length === 1;
    });
  }
  function render(state) {
    const {container, config, card, radios, index} = state;
    const values = readOptions(state), variant = selected(state);
    if (state.announcedVariantId && (!variant || idOf(variant.id) !== state.announcedVariantId)) {
      const announced = card.querySelector('[data-optional-case-announce]');
      if (announced) announced.textContent = '';
      state.announcedVariantId = null;
    }
    const pair = pairFor(config.variants, values, index, config.without, config.with);
    const upgrade = upgradeFor(pair, config.referencePrice);
    const isWith = values[index] === config.with;
    const withAvailable = !!(pair.with && pair.with.available);
    const withOk = withAvailable && (!!upgrade || (isWith && variant === pair.with));
    const withoutOk = !!(pair.without && pair.without.available);
    radios.with.checked = isWith;
    radios.without.checked = !isWith;
    // A disabled tile stays visible with its reason; the current choice is never silently changed.
    radios.with.disabled = !withOk;
    radios.without.disabled = !withoutOk;
    const offer = withOk ? upgrade : null;
    card.querySelector('[data-optional-case-upgrade]').textContent = offer ? (offer.amount === 0 ? 'Free' : '+ ' + money(offer.amount, config)) : withAvailable ? (isWith ? 'Included in selected total' : 'Upgrade price unavailable') : 'Not available with this size';
    // One currency format in the card: re-render the server-side reference with the same formatter.
    const reference = card.querySelector('[data-optional-case-reference]');
    const showReference = !!offer && offer.saving > 0;
    reference.hidden = !showReference;
    reference.textContent = showReference ? 'Sold separately for ' + money(config.referencePrice, config) : '';
    // Nothing is shown when all is well, so no line appears or vanishes under the shopper's thumb.
    let message = '';
    if (!variant || !variant.available) message = isWith && !withOk && withoutOk ? 'The case isn’t available with this size. Choose “Without travel case” or another size.' : 'This option is unavailable. Choose another size.';
    card.querySelector('[data-optional-case-status]').textContent = message;
    renderSheet(state, offer, isWith, withOk, withAvailable);
    container.dataset.optionalCaseVariant = variant ? idOf(variant.id) : '';
    const details = container.closest('.product__details') || container.parentElement;
    details.querySelectorAll('[data-optional-case-authenticity]').forEach(panel => {
      if (panel.getAttribute('data-optional-case-authenticity') !== idOf(config.productId)) return;
      const sku = variant ? idOf(variant.sku) : '';
      panel.querySelectorAll('[data-optional-case-sku]').forEach(chip => {
        chip.textContent = sku ? 'SKU: ' + sku : '';
        chip.hidden = !sku;
      });
    });
    productNodes(state,'[data-optional-case-includes]','data-optional-case-includes').forEach(el => {el.textContent = !variant ? 'Choose an available configuration.' : isWith ? 'Includes one ' + (config.caseLabel || 'travel case') + '.' : 'Travel case optional.';});
    productNodes(state,'[data-optional-case-instalment]','data-optional-case-instalment').forEach(el => {el.textContent = variant ? money(Math.round(variant.price / 4), config) : '—';});
      win.document.querySelectorAll('script[data-optional-case-schema]').forEach(el => {
        if (el.dataset.optionalCaseSchema !== idOf(config.productId)) return;
        try {
          const data = JSON.parse(el.textContent);
          if (!variant) {
            delete data.offers;delete data.sku;delete data.mpn;
            el.textContent = JSON.stringify(data);return;
          }
          if (!data.offers || typeof data.offers !== 'object' || Array.isArray(data.offers)) data.offers = {'@type':'Offer'};
          data.sku = variant.sku;
          // A combined configuration has its own GTIN; never retain another variant's barcode.
          if (variant.barcode) data.mpn = variant.barcode; else delete data.mpn;
          data.offers.price = variant.price / 100;
          data.offers.priceCurrency = config.currency;
          data.offers.availability = 'http://schema.org/' + (variant.available ? 'InStock' : 'OutOfStock');
          const url = new URL(config.productUrl || win.location.pathname, win.location.origin);url.searchParams.set('variant', variant.id);url.hash = '';
          data.offers.url = url.href;
          el.textContent = JSON.stringify(data);
        } catch (_) { /* Native form remains authoritative when an unrelated schema block is malformed. */ }
      });
  }
  function focusTarget(target) {
    if (!target || !target.isConnected || typeof target.focus !== 'function') return;
    try { target.focus({preventScroll:true}); } catch (_) { target.focus(); }
  }
  function imageAssetKey(value) {
    if (!value) return '';
    try {
      const url = new URL(value,win.location.href);
      if (!['http:','https:'].includes(url.protocol)) return '';
      const path = decodeURIComponent(url.pathname);
      // Shopify can serve the same asset through the shop proxy or s/files CDN.
      // Keep its asset directory/name, ignoring host, version and width queries.
      const start = Math.max(path.lastIndexOf('/files/'),path.lastIndexOf('/products/'));
      return start >= 0 ? path.slice(start+1) : path;
    } catch (_) { return ''; }
  }
  function sheetReturnTarget(state, choice, fallback) {
    // Variant/theme work can replace a control while native close is queued.
    // Resolve the semantic choice again instead of focusing a detached node.
    const card = state.container.querySelector('[data-optional-case-card]');
    const control = choice && card?.querySelector('[data-optional-case-choice="' + choice + '"]');
    if (control?.isConnected && !control.disabled) return control;
    return fallback?.isConnected ? fallback : (state.opener?.isConnected ? state.opener : null);
  }
  function restoreSheetFocus(state, generation, choice, fallback) {
    focusTarget(sheetReturnTarget(state,choice,fallback));
    const recover = () => {
      if (state.unloading || !state.container.isConnected || state.sheet.open || state.sheetGeneration !== generation || state.closedSheetGeneration !== generation) return;
      const target = sheetReturnTarget(state,choice,fallback), active = win.document.activeElement;
      if (active === target) return;
      // Native modal inertness/focus cleanup can finish after the close event.
      // Recover a lost focus, but never steal a later intentional page action.
      if (active && active !== win.document.body && active !== win.document.documentElement && active !== state.opener && !state.sheet.contains(active)) return;
      focusTarget(target);
    };
    if (typeof win.requestAnimationFrame === 'function') win.requestAnimationFrame(recover);
    else win.setTimeout(recover,0);
  }
  function lockSheetScroll(state) {
    if (openSheets.has(state)) return;
    if (openSheets.size === 0) {
      scrollSnapshot = [win.document.documentElement, win.document.body].map(el => ({el,value:el.style.getPropertyValue('overflow'),priority:el.style.getPropertyPriority('overflow')}));
      scrollSnapshot.forEach(item => item.el.style.setProperty('overflow','hidden'));
    }
    openSheets.add(state);
  }
  function releaseSheetScroll(state) {
    if (!openSheets.delete(state) || openSheets.size !== 0 || !scrollSnapshot) return;
    scrollSnapshot.forEach(item => {
      if (item.el.style.getPropertyValue('overflow') !== 'hidden' || item.el.style.getPropertyPriority('overflow')) return;
      if (item.value) item.el.style.setProperty('overflow',item.value,item.priority);
      else item.el.style.removeProperty('overflow');
    });
    scrollSnapshot = null;
  }
  function resetCachedSheet(state) {
    const sheet = state.sheet;
    if (!sheet || !sheet.open && !openSheets.has(state)) return;
    const wasOpen = sheet.open, generation = state.sheetGeneration;
    const active = win.document.activeElement;
    const restoreFocus = wasOpen || !active || active === win.document.body || active === win.document.documentElement || sheet.contains(active);
    const fallback = state.opener?.isConnected ? state.opener : null;
    const choice = fallback ? null : (selected(state)?.options[state.index] === state.config.with ? 'with' : 'without');
    // A cached details panel is transient UI, not a saved merchandise choice.
    // Suppress its queued close task, release only our own lock, and let the
    // browser retain its restored scroll position and native variant controls.
    state.closedSheetGeneration = generation;
    state.returnFocus = null;state.returnFocusChoice = null;
    if (sheet.open) { try { sheet.close(); } catch (_) { sheet.removeAttribute('open'); } }
    if (sheet.open || state.sheetGeneration !== generation) return;
    releaseSheetScroll(state);stopWatchingSheet(state);
    if (restoreFocus) restoreSheetFocus(state,generation,choice,fallback);
  }
  function renderSheet(state, offer, isWith, withOk, withAvailable) {
    const sheet = state.sheet;
    if (!sheet) return;
    sheet.querySelector('[data-optional-case-sheet-upgrade]').textContent = offer ? (offer.amount === 0 ? 'Free with this item' : '+ ' + money(offer.amount,state.config) + ' with this item') : (isWith && withOk ? 'Included in selected total' : '');
    const reference = sheet.querySelector('[data-optional-case-sheet-reference]');
    reference.hidden = !offer || offer.saving <= 0;
    reference.textContent = reference.hidden ? '' : 'Sold separately for ' + money(state.config.referencePrice,state.config);
    const message = sheet.querySelector('[data-optional-case-sheet-state]');
    message.textContent = withOk ? (isWith ? 'Included in your selected item.' : '') : (withAvailable ? 'The upgrade price cannot be confirmed for this size.' : 'Not available with this size.');
    message.dataset.tone = withOk ? 'ok' : 'muted';
    const add = sheet.querySelector('[data-optional-case-sheet-add]');
    add.dataset.mode = withOk && !isWith ? 'add' : 'close';
    add.textContent = add.dataset.mode === 'add' ? 'Add case' : (withOk ? 'Done' : 'Close');
  }
  function updateGallery(state, index, move) {
    const sheet = state.sheet, gallery = sheet?.querySelector('[data-optional-case-gallery]');
    if (!gallery) return;
    const items = Array.from(gallery.querySelectorAll('[data-optional-case-gallery-item]'));
    if (!items.length) return;
    const nextIndex = Math.max(0,Math.min(items.length-1,index));
    state.galleryIndex = nextIndex;
    const counter = sheet.querySelector('[data-optional-case-gallery-count]');
    const text = (nextIndex+1) + ' of ' + items.length;
    if (counter && counter.textContent !== text) counter.textContent = text;
    const previous = sheet.querySelector('[data-optional-case-gallery-prev]'), next = sheet.querySelector('[data-optional-case-gallery-next]');
    // Moving focus before disabling the active arrow avoids the browser dropping
    // it to body at either boundary. The existing photo region is keyboard-ready.
    const active = win.document.activeElement;
    if (sheet.open && (active === previous && nextIndex === 0 || active === next && nextIndex === items.length-1)) focusTarget(gallery);
    if (previous) previous.disabled = nextIndex === 0;
    if (next) next.disabled = nextIndex === items.length-1;
    if (move) {
      const offset = items[nextIndex].offsetLeft-items[0].offsetLeft;
      const left = offset || nextIndex*(gallery.clientWidth || 1);
      // Instant button navigation avoids animated counter churn; swiping stays native.
      try {
        if (typeof gallery.scrollTo === 'function') gallery.scrollTo({left,behavior:'instant'});
        else gallery.scrollLeft = left;
      } catch (_) { gallery.scrollLeft = left; }
    }
  }
  function restoreDetailsLinks(state) {
    state.detailsTriggers?.forEach(({button,anchor}) => { if (button.isConnected) button.replaceWith(anchor); });
    state.sheetDisabled = true;
  }
  function stopWatchingSheet(state) {
    state.detachmentObserver?.disconnect();
    state.detachmentObserver = null;
    if (state.onSectionUnload) win.document?.removeEventListener('shopify:section:unload',state.onSectionUnload);
  }
  function watchSheet(state) {
    if (state.onSectionUnload) win.document.addEventListener('shopify:section:unload',state.onSectionUnload);
    if (typeof win.MutationObserver !== 'function') return;
    state.detachmentObserver?.disconnect();
    state.detachmentObserver = new win.MutationObserver(() => {
      if (state.container.isConnected && state.sheet.isConnected) return;
      state.unloading = true;
      try { if (state.sheet.open) state.sheet.close(); } catch (_) { state.sheet.removeAttribute('open'); }
      releaseSheetScroll(state);stopWatchingSheet(state);
    });
    state.detachmentObserver.observe(win.document.body,{childList:true,subtree:true});
  }
  function openSheet(state, trigger) {
    if (!state.sheet || state.sheetDisabled || !state.container.isConnected) return;
    state.opener = trigger;
    state.unloading = false;
    state.returnFocus = null;
    state.returnFocusChoice = null;
    render(state);
    try {
      if (!state.sheet.open) { state.sheetGeneration++;state.sheet.showModal(); }
      lockSheetScroll(state);
      watchSheet(state);
      const imageId = trigger.getAttribute('data-optional-case-image-id');
      const galleryImages = Array.from(state.sheet.querySelectorAll('[data-optional-case-gallery-item]'));
      const imageKey = imageAssetKey(trigger.getAttribute('data-optional-case-image-key') || trigger.querySelector('img')?.getAttribute('src'));
      let photoIndex = imageKey ? galleryImages.findIndex(image => imageAssetKey(image.getAttribute('data-optional-case-image-key') || image.getAttribute('src')) === imageKey) : -1;
      if (photoIndex < 0 && !imageKey && imageId) photoIndex = galleryImages.findIndex(image => image.getAttribute('data-optional-case-image-id') === imageId);
      const isPhoto = trigger.classList.contains('optional-case-card__photo') || trigger.hasAttribute('data-optional-case-image-key') || trigger.hasAttribute('data-optional-case-image-id');
      updateGallery(state,isPhoto ? Math.max(0,photoIndex) : (state.galleryIndex || 0),isPhoto);
      focusTarget(state.sheet.querySelector('[data-optional-case-sheet-title]'));
    } catch (_) {
      if (state.sheet.open) { try { state.sheet.close(); } catch (_) { state.sheet.removeAttribute('open'); } }
      releaseSheetScroll(state);
      stopWatchingSheet(state);
      const fallback = state.detailsTriggers.find(item => item.button === trigger)?.anchor;
      restoreDetailsLinks(state);
      state.card.querySelector('[data-optional-case-status]').textContent = 'Open the case page for photos and details.';
      focusTarget(fallback);
    }
  }
  function bindSheet(state) {
    const sheet = state.container.querySelector('[data-optional-case-sheet]');
    if (!sheet || typeof sheet.showModal !== 'function' || typeof sheet.close !== 'function') return;
    const hooks = ['sheet-title','sheet-close','sheet-upgrade','sheet-reference','sheet-state','sheet-add'];
    if (hooks.some(hook => !sheet.querySelector('[data-optional-case-' + hook + ']'))) return;
    state.sheet = sheet;
    state.sheetGeneration = 0;
    state.closedSheetGeneration = -1;
    sheet.id = state.group + '-sheet';
    const heading = sheet.querySelector('[data-optional-case-sheet-title]');
    heading.id = state.group + '-sheet-title';
    sheet.setAttribute('aria-labelledby',heading.id);
    state.detailsTriggers = [];
    state.container.querySelectorAll('a[data-optional-case-details]').forEach(anchor => {
      // Actual buttons avoid native-link/theme-navigation conflicts; original links
      // remain available when enhancement is unsupported or opening fails.
      const button = win.document.createElement('button');
      Array.from(anchor.attributes).forEach(attribute => {
        if (!['href','target','rel','role'].includes(attribute.name)) button.setAttribute(attribute.name,attribute.value);
      });
      button.type = 'button';button.setAttribute('form','');
      button.setAttribute('aria-haspopup','dialog');button.setAttribute('aria-controls',sheet.id);
      while (anchor.firstChild) button.appendChild(anchor.firstChild);
      // Keep a complete real-link fallback, including the photo and its accessible name.
      const fallback = anchor.cloneNode(false);
      Array.from(button.childNodes).forEach(node => fallback.appendChild(node.cloneNode(true)));
      anchor.replaceWith(button);
      state.detailsTriggers.push({button,anchor:fallback});
      button.addEventListener('click',() => openSheet(state,button));
    });
    sheet.querySelectorAll('[data-optional-case-sheet-close]').forEach(button => button.addEventListener('click',() => sheet.close()));
    sheet.addEventListener('cancel',event => { event.preventDefault();sheet.close(); });
    sheet.addEventListener('click',event => {
      if (event.target !== sheet || event.detail === 0) return;
      const rect = sheet.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) sheet.close();
    });
    sheet.querySelector('[data-optional-case-sheet-add]').addEventListener('click',() => {
      if (sheet.querySelector('[data-optional-case-sheet-add]').dataset.mode === 'add' && !state.radios.with.disabled) {
        state.radios.with.click();
        const chosen = selected(state), field = state.selector.variantIdField;
        if (!chosen || chosen.options[state.index] !== state.config.with || field.disabled || idOf(field.value) !== idOf(chosen.id)) {
          render(state);
          const message = sheet.querySelector('[data-optional-case-sheet-state]');
          message.textContent = 'The case choice could not be confirmed. Close this panel and try again.';
          message.setAttribute('tabindex','-1');focusTarget(message);return;
        }
        state.returnFocus = state.radios.with;
        state.returnFocusChoice = 'with';
      }
      sheet.close();
    });
    sheet.addEventListener('close',() => {
      // Native close events are queued: an older one must not unlock or refocus
      // a newer opening, or handle the same closed generation twice.
      if (sheet.open || state.closedSheetGeneration === state.sheetGeneration) return;
      state.closedSheetGeneration = state.sheetGeneration;
      releaseSheetScroll(state);
      stopWatchingSheet(state);
      if (!state.unloading) restoreSheetFocus(state,state.sheetGeneration,state.returnFocusChoice,state.returnFocus || state.opener);
      state.returnFocus = null;
      state.returnFocusChoice = null;
    });
    const gallery = sheet.querySelector('[data-optional-case-gallery]');
    if (gallery) {
      const previous = sheet.querySelector('[data-optional-case-gallery-prev]'), next = sheet.querySelector('[data-optional-case-gallery-next]');
      if (previous) previous.addEventListener('click',() => updateGallery(state,(state.galleryIndex || 0)-1,true));
      if (next) next.addEventListener('click',() => updateGallery(state,(state.galleryIndex || 0)+1,true));
      gallery.addEventListener('scroll',() => {
        const items = Array.from(gallery.querySelectorAll('[data-optional-case-gallery-item]'));
        if (!items.length || items.every(item => item.offsetLeft === items[0].offsetLeft)) return;
        const position = gallery.scrollLeft;
        let index=0;
        items.forEach((item,i) => { if (Math.abs(item.offsetLeft-items[0].offsetLeft-position) < Math.abs(items[index].offsetLeft-items[0].offsetLeft-position)) index=i; });
        updateGallery(state,index,false);
      },{passive:true});
      updateGallery(state,0,false);
    }
    state.onSectionUnload = event => {
      if (!event.target?.contains(state.container)) return;
      state.unloading = true;
      if (sheet.open) sheet.close();
      releaseSheetScroll(state);
      stopWatchingSheet(state);
    };
  }
  function announce(state, key) {
    // Screen readers hear the new total once, only after a real change; nothing visible moves.
    const el = state.card.querySelector('[data-optional-case-announce]');
    const variant = selected(state);
    const expected = key === 'with' ? state.config.with : state.config.without;
    if (!el || !variant || readOptions(state)[state.index] !== expected) return;
    el.textContent = (key === 'with' ? 'Travel case added. ' : 'Travel case removed. ') + 'Total ' + money(variant.price, state.config) + ' per item.';
    state.announcedVariantId = idOf(variant.id);
  }
  function retireState(state) {
    state.unloading = true;
    if (state.sheet?.open) state.sheet.close();
    releaseSheetScroll(state);stopWatchingSheet(state);
    if (state.onPageShow) win.removeEventListener('pageshow',state.onPageShow);
    if (state.onAddClick) state.nativeForm.removeEventListener('click',state.onAddClick);
    state.hiddenNativeAxis?.forEach(node => node.classList.remove('optional-case-native-axis'));
    states.delete(state.container);
  }
  function concealNativeAxis(state) {
    const control = state.selector.selectors[state.index]?.element;
    const field = state.selector.variantIdField;
    const nodes = [control?.closest('.selector-wrapper')];
    // For a sole option Turbo prints a server label outside the generated
    // wrapper. Keep native fallback intact until this card has bound correctly.
    if (state.config.options.length === 1 && field?.parentElement) {
      Array.from(field.parentElement.children).forEach(node => {
        if (node.tagName === 'LABEL' && node.textContent.trim() === state.config.caseOption && (!node.htmlFor || node.htmlFor === field.id || node.htmlFor === control?.id)) nodes.push(node);
      });
    }
    state.hiddenNativeAxis ||= new Set();
    nodes.filter(Boolean).forEach(node => {node.classList.add('optional-case-native-axis');state.hiddenNativeAxis.add(node);});
  }
  function bind(container, selector) {
    if (!win || !container || !selector || !Array.isArray(selector.selectors)) return false;
    if (selector.variantIdField !== container.querySelector('select[name="id"]') || selector.selectors.some(item => !container.contains(item.element))) return false;
    if (states.has(container)) {
      const previous = states.get(container);
      if (previous.card !== container.querySelector('[data-optional-case-card]') || previous.nativeForm !== container.querySelector('form')) retireState(previous);
      else {
      // Reinitialisation gets a new native selector, while one UI/controller stays attached.
      previous.selector = selector;
      concealNativeAxis(previous);
      render(previous);return true;
      }
    }
    const tag = container.querySelector('[data-optional-case-config]');
    const card = container.querySelector('[data-optional-case-card]');
    if (!tag || !card) return false;
    let config;
    try { config = JSON.parse(tag.getAttribute('data-optional-case-config') || tag.textContent); } catch (_) { return false; }
    const index = Array.isArray(config.options) ? config.options.indexOf(config.caseOption) : -1;
    if (index < 0 || !Array.isArray(config.variants) || !selector.selectors[index] || !Number.isSafeInteger(config.referencePrice) || config.referencePrice <= 0) return false;
    if (!['set','master_set'].includes(config.form) || config.caseOption !== 'Travel case' || config.without !== 'Without travel case' || typeof config.with !== 'string' || !config.with.startsWith('With ') || config.with.length <= 5 || config.with.length > 120 || config.variants.some(v => !v || !Array.isArray(v.options) || v.options.length !== config.options.length || ![config.without,config.with].includes(v.options[index]))) return false;
    const radios = {without: card.querySelector('[data-optional-case-choice="without"]'), with: card.querySelector('[data-optional-case-choice="with"]')};
    const nativeForm = container.querySelector('form');
    if (!radios.without || !radios.with || !nativeForm || selector.variantIdField !== container.querySelector('select[name="id"]') || selector.selectors.some(item => !container.contains(item.element))) return false;
    if (!card.querySelector('[data-optional-case-upgrade]') || !card.querySelector('[data-optional-case-reference]') || !card.querySelector('[data-optional-case-status]')) return false;
    const group = 'optional-case-ui-' + idOf(config.productId) + '-' + (++choiceGroup);
    const legendTitle = card.querySelector('[data-optional-case-legend-title]');
    if (legendTitle) { legendTitle.id = group + '-legend';card.setAttribute('aria-labelledby',legendTitle.id); }
    ['without', 'with'].forEach(function(key) {
      radios[key].name = group;
      radios[key].id = group + '-' + key;
      radios[key].setAttribute('form', '');
      const title = card.querySelector('[data-optional-case-title="' + key + '"]');
      if (title) { title.id = group + '-' + key + '-title';radios[key].setAttribute('aria-labelledby', title.id); }
    });
    const detail = card.querySelector('[data-optional-case-detail]');
    if (detail) { detail.id = group + '-detail';radios.with.setAttribute('aria-describedby', detail.id); }
    const state = {container, config, selector, card, radios, index, group, nativeForm};
    states.set(container, state);
    bindSheet(state);
    ['without', 'with'].forEach(function (key) {
      radios[key].addEventListener('change', function () {
        if (!radios[key].checked) return;
        const current = readOptions(state), pair = pairFor(config.variants, current, index, config.without, config.with);
        const target = key === 'with' ? pair.with : pair.without;
        if (!target || !target.available || (key === 'with' && !upgradeFor(pair, config.referencePrice) && target !== selected(state))) {render(state);return;}
        const control = state.selector.selectors[index].element;
        control.value = target.options[index];
        // This is Turbo's generated native option control. Its onchange invokes
        // OptionSelectors, PriceUI, availability, payment terms and native ID together.
        control.dispatchEvent(new win.Event('change', {bubbles:true}));
        const confirmed = selected(state), field = state.selector.variantIdField;
        if (!confirmed || field.disabled || idOf(field.value) !== idOf(confirmed.id)) {
          // The native master remains authoritative if another theme handler
          // prevents the option update. Restore the UI to that confirmed ID.
          const nativeVariant = config.variants.find(v => idOf(v.id) === idOf(field.value));
          if (nativeVariant && !field.disabled) state.selector.selectors.forEach((item,i) => { item.element.value = nativeVariant.options[i]; });
          render(state);
          card.querySelector('[data-optional-case-status]').textContent = 'The case choice could not be updated. Please try again.';
          return;
        }
        render(state);
        announce(state, key);
      });
    });
    state.onAddClick = function(event) {
      const button = event.target.closest('button[name="add"]');
      if (!button || button.disabled) return;
      const variant = selected(state);
      if (!variant || !variant.available || !Array.isArray(win.dataLayer)) return;
      const quantity = Math.max(1, Number(container.querySelector('[name="quantity"]')?.value || 1));
      win.dataLayer.push({ecommerce:null});
      win.dataLayer.push({event:'add_to_cart', ecommerce:{currency:config.currency, value:variant.price / 100 * quantity, items:[{item_id:idOf(config.productId), item_name:config.title, item_brand:config.vendor, item_variant:variant.sku, price:variant.price / 100, quantity}]}});
    };
    nativeForm.addEventListener('click',state.onAddClick);
    state.onPageShow = function(event) {
      if (!event.persisted || !container.isConnected) return;
      resetCachedSheet(state);render(state);
    };
    win.addEventListener('pageshow',state.onPageShow);
    concealNativeAxis(state);
    container.classList.add('optional-case-bound');
    render(state);card.hidden = false;return true;
  }
  function update(container) { const state = states.get(container);if (state) render(state); }
  return {initialVariant, pairFor, upgradeFor, catalogueMatch, formatPrice, bind, update};
});
